import { createFileRoute } from '@tanstack/react-router';
import DoneFaresPage from '../../../features/patient-transport/pages/DoneFaresPage';
import { getDailyFaresQueryOptions } from '../../../features/patient-transport/queries';

export const Route = createFileRoute('/_auth/patient-transport/fares/done')({
  component: DoneFaresPage,
  loader: ({ context: { queryClient, authenticationContext } }) => {
    if (!authenticationContext.user?.porter) {
      return undefined;
    }
    return queryClient.ensureQueryData(getDailyFaresQueryOptions());
  },
});
